import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ConstantsService} from '../ConstantsService';
import {VendasPedidoService} from '../../services/vendas-pedido.service';
import {PedidosService} from '../../services/pedidos.service';
import {EmpresasService} from '../../superadmin/services/empresas.service';
import {RedesService} from '../../services/redes.service';
import {GridPedidosComponent} from '../../pedidos/grid-pedidos/grid-pedidos.component';
import {AggregateDescriptor, GroupDescriptor, orderBy, process, SortDescriptor} from '@progress/kendo-data-query';
import {SelectEvent} from '@progress/kendo-angular-layout';

declare var moment;

@Component({
  selector: 'app-financeiro-mesas-v2',
  templateUrl: './financeiro-mesas-v2.component.html',
  styleUrls: ['./financeiro-mesas-v2.component.scss']
})
export class FinanceiroMesasV2Component implements OnInit {
  @ViewChild('gridPedidos', { static: false}) gridPedidos: GridPedidosComponent;

  filtro: any = {comanda: 'ambas'};
  empresa: any = {};
  rede = false;
  redes: any = [];

  abaPrincipalAtiva: 'loja' | 'vendas' | 'produtos' | 'garcons' = 'vendas';

  resumoVendas: any = {
    total: 0,
    qtde: 0,
    ticketMedio: 0,
    totalTaxaServico: 0,
    totalComTaxa: 0,
    formasDePagamento: [],
    diarias: [],
    lojas: []
  };

  resumoProdutos: any = {
    produtos: [],
    carregando: false,
    totalDescontos: 0
  };

  resumoGarcons: any = {
    garcons: [],
    carregando: false
  };

  carregando = false;
  vendasDoDia: any;
  garcons: any = [];
  sortLoja: SortDescriptor[] = [{dir: 'desc', field: 'qtde'}];
  vendasLojasResultSet: any;

  // layout v2
  quickDateFilter: 'hoje' | 'ontem' | '7dias' | '30dias' | 'mes' | 'mesAnterior' | 'personalizado' = 'mes';
  mostrarFiltrosAvancados = false;
  chartLabels: string[] = [];
  chartDiasUteis: Array<number | null> = [];
  chartFimSemana: Array<number | null> = [];

  public aggregates: AggregateDescriptor[] = [
    { field: 'qtde', aggregate: 'sum' },
    { field: 'total', aggregate: 'sum' },
    { field: 'totalDesconto', aggregate: 'sum' }
  ];

  public group: GroupDescriptor[] = [
    { field: 'Produtos', aggregates: this.aggregates }
  ];

  constructor(private router: Router,
              private constantsService: ConstantsService,
              private pedidosService: PedidosService,
              private vendasService: VendasPedidoService,
              private empresaService: EmpresasService,
              private redesService: RedesService) {
    this.rede = this.router.url.indexOf('/admin-rede') !== -1;

    if (this.rede) {
      this.redes = this.redesService.redesEmpresa();
    }

    this.constantsService.empresa$.subscribe((empresa: any) => {
      if (empresa) {
        this.empresa = empresa;
        this.carregueGarcons();
      }
    });
  }

  ngOnInit(): void {
    this.abaPrincipalAtiva = this.rede ? 'loja' : 'vendas';
    this.filtro.inicio = moment().startOf('month').toDate();
    this.filtro.fim = moment().endOf('day').toDate();
    this.carregueResumoVendas();
  }

  private carregueGarcons() {
    this.empresaService.listeGarcons(this.empresa).then((resposta: any) => {
      this.garcons = resposta?.data || [];
    }).catch(() => {
      this.garcons = [];
    });
  }

  onPeriodoAlterado(evento: {inicio: Date, fim: Date, quickDateFilter: string}) {
    this.filtro.inicio = evento.inicio;
    this.filtro.fim = evento.fim;
    this.quickDateFilter = evento.quickDateFilter as any;
    this.carregueResumoVendas();
  }

  toggleFiltrosAvancados() {
    this.mostrarFiltrosAvancados = !this.mostrarFiltrosAvancados;
  }

  prepareChartData() {
    this.chartLabels = [];
    this.chartDiasUteis = [];
    this.chartFimSemana = [];

    if (!this.resumoVendas.diarias || this.resumoVendas.diarias.length <= 1) {
      return;
    }

    const diariasOrdenadas = [...this.resumoVendas.diarias].sort((a: any, b: any) =>
      moment(a.dia, 'DD/MM/YYYY').valueOf() - moment(b.dia, 'DD/MM/YYYY').valueOf()
    );

    diariasOrdenadas.forEach((resumoDia: any) => {
      const data = moment(resumoDia.dia, 'DD/MM/YYYY');
      const diaSemana = data.day();
      const isWeekend = diaSemana === 0 || diaSemana === 6;
      const valor = resumoDia.totalComTaxa || resumoDia.total || 0;

      this.chartLabels.push(data.format('DD/MM'));

      if (isWeekend) {
        this.chartDiasUteis.push(null);
        this.chartFimSemana.push(valor);
      } else {
        this.chartDiasUteis.push(valor);
        this.chartFimSemana.push(null);
      }
    });
  }

  carregueResumoVendas() {
    if (this.carregando) {
      return;
    }

    this.carregando = true;

    this.vendasService.obtenhaResumoComandas(this.obtenhaFiltro()).then((resposta: any) => {
      this.carregando = false;
      this.resumoVendas = resposta;

      this.resumoProdutos = {produtos: [], carregando: false, totalDescontos: 0};
      this.resumoGarcons = {garcons: [], carregando: false};
      delete this.vendasDoDia;

      if (resposta?.lojas) {
        this.vendasLojasResultSet = orderBy(process(resposta.lojas, {}).data, this.sortLoja);
      }

      this.prepareChartData();

      if (this.abaPrincipalAtiva === 'produtos') {
        this.carregueResumoProdutos();
      } else if (this.abaPrincipalAtiva === 'garcons') {
        this.carregueResumoGarcons();
      }
    }).catch((erro) => {
      this.carregando = false;
      console.error('Erro ao carregar resumo de mesas:', erro);
    });
  }

  public carregueResumoProdutos() {
    if (!this.filtro.porAdicionais) {
      this.group[0].field = 'Produtos';
      this.resumoProdutos.carregando = true;
      this.vendasService.obtenhaResumoPrudutos(this.obtenhaFiltro()).then((resposta) => {
        this.resumoProdutos.carregando = false;
        this.resumoProdutos = resposta;
      }).catch((erro) => {
        this.resumoProdutos.carregando = false;
        alert(erro);
      });
    } else {
      this.group[0].field = 'Adicionais';
      this.resumoProdutos.carregando = true;
      this.vendasService.obtenhaResumoAdicionais(this.obtenhaFiltro()).then((resposta: any) => {
        this.resumoProdutos.carregando = false;
        this.resumoProdutos = resposta;
        this.resumoProdutos.produtos = resposta?.adicionais || [];
      }).catch((erro) => {
        this.resumoProdutos.carregando = false;
        alert(erro);
      });
    }
  }

  private carregueResumoGarcons() {
    this.resumoGarcons.carregando = true;

    this.vendasService.obtenhaResumoGarcons(this.obtenhaFiltro()).then((resposta) => {
      this.resumoGarcons.carregando = false;
      this.resumoGarcons = resposta;
    }).catch((erro) => {
      this.resumoGarcons.carregando = false;
      alert(erro);
    });
  }

  obtenhaFiltro() {
    const dados: any = {mesas: true, pg: 1};

    const dtInicio = this.filtro.inicio ? moment(this.filtro.inicio).format('YYYYMMDD') : null;
    const dtFim = this.filtro.fim ? moment(this.filtro.fim).format('YYYYMMDD') : null;

    const formaDePagamento = this.filtro.formasDePagamento && this.filtro.formasDePagamento.length > 0
      ? this.filtro.formasDePagamento.map((forma: any) => forma.id).join(',')
      : null;

    const garcons = this.filtro.garcons && this.filtro.garcons.length > 0
      ? this.filtro.garcons.map((garcom: any) => garcom.id).join(',')
      : null;

    if (dtInicio) {
      dados.di = dtInicio;
    }

    if (dtFim) {
      dados.df = dtFim;
    }

    if (formaDePagamento) {
      dados.fp = formaDePagamento;
    }

    if (garcons) {
      dados.gs = garcons;
    }

    if (this.rede) {
      dados.r = 1;
    }

    if (this.filtro.rede) {
      dados.rid = this.filtro.rede.id;
    }

    if (this.filtro.porAdicionais) {
      dados.pad = true;
    }

    if (this.filtro.comanda === 'multiplo') {
      dados.pm = true;
    }

    if (this.filtro.comanda === 'unico') {
      dados.pu = true;
    }

    return dados;
  }

  verPedidos(resumoDia: any) {
    this.vendasDoDia = resumoDia;

    if (this.vendasDoDia.pedidos && this.vendasDoDia.pedidos.length) {
      return;
    }

    this.vendasDoDia.carregando = true;

    const dia = moment(this.vendasDoDia.dia, 'DD/MM/YYYY').format('YYYYMMDD');

    const filtro: any = {
      apenasPagos: true,
      dtInicio: dia,
      dtFim: dia,
      destino: 'mesas'
    };

    if (this.rede) {
      filtro.r = 1;
    }

    this.pedidosService.listePedidos(0, 10000, filtro).then((resposta) => {
      this.vendasDoDia.pedidos = resposta ? (resposta.pedidos || []) : [];
      this.vendasDoDia.carregando = false;
      this.gridPedidos.atualizeGridPedidos(this.vendasDoDia.pedidos, 'mesas');
    }).catch(() => {
      this.vendasDoDia.carregando = false;
    });
  }

  async selecionouTab($event: SelectEvent) {
    this.atualizeAbaPrincipalAtiva($event);

    if ($event.title.indexOf('Produtos') >= 0 && (!this.resumoProdutos.produtos || !this.resumoProdutos.produtos.length)) {
      this.carregueResumoProdutos();
    }

    if (($event.title.indexOf('Garç') >= 0 || $event.title.indexOf('Garcom') >= 0) &&
      (!this.resumoGarcons.garcons || !this.resumoGarcons.garcons.length)) {
      this.carregueResumoGarcons();
    }
  }

  private atualizeAbaPrincipalAtiva($event: SelectEvent) {
    const titulo = String($event.title || '').toLowerCase();

    if (titulo.indexOf('por loja') >= 0) {
      this.abaPrincipalAtiva = 'loja';
      return;
    }

    if (titulo.indexOf('vendas diárias') >= 0 || titulo.indexOf('vendas diarias') >= 0) {
      this.abaPrincipalAtiva = 'vendas';
      return;
    }

    if (titulo.indexOf('por produtos') >= 0) {
      this.abaPrincipalAtiva = 'produtos';
      return;
    }

    if (titulo.indexOf('garç') >= 0 || titulo.indexOf('garcom') >= 0) {
      this.abaPrincipalAtiva = 'garcons';
    }
  }

  voltarVendasDia() {
    delete this.vendasDoDia;
  }

  sortChangeLojas(sort: SortDescriptor[]) {
    this.sortLoja = sort;
    this.vendasLojasResultSet = orderBy(process(this.resumoVendas.lojas, {}).data, this.sortLoja);
  }

  obtenhaDescricaoFiltro() {
    if (moment(this.filtro.inicio).isSame(moment(this.filtro.fim), 'day')) {
      return String(` do dia ${moment(this.filtro.inicio).format('DD/MM/YYYY')}`);
    }

    return String(`entre ${moment(this.filtro.inicio).format('DD/MM/YYYY')} e ${moment(this.filtro.fim).format('DD/MM/YYYY')}`);
  }

  obtenhaNomeArquivoDownload(nome: string) {
    const inicio = moment(this.filtro.inicio).format('DD-MM-YYYY');
    const fim = moment(this.filtro.fim).format('DD-MM-YYYY');

    if (this.filtro.rede) {
      nome = String(`${nome}-${this.filtro.rede.nome.toLowerCase()}`);
    }

    const sufixo = String(`${inicio}_e_${fim}`);

    return String(`${nome}(${sufixo}).xls`);
  }
}
